// removed by extract-text-webpack-plugin
module.exports = {"cat":"cat__cat___31oSZ"};


//////////////////
// WEBPACK FOOTER
// ./src/js/Components/Cat/cat.scss
// module id = 119
// module chunks = 0